import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import {
  AnnouncementsActionTypes,
  GetAnnouncementsSuccess,
  GetAnnouncementSuccess
} from '../../actions/announcements/announcements.actions';
import { exhaustMap, map } from 'rxjs/operators';
import { AnnouncementsService } from '../../services/announcements/announcements.service';

@Injectable()
export class AnnouncementsEffects {
  @Effect()
  public getAnnouncements() {
    return this.actions.pipe(
      ofType(AnnouncementsActionTypes.GET_ANNOUNCEMENTS),
      exhaustMap((action: any) => {
        return this.announcementsService.getAnnouncements(action.paging).pipe(
          map(response =>
            GetAnnouncementsSuccess({
              announcements: response.results.map(item => ({
                id: item.id,
                title: item.subject,
                description: item.message.replace(/<[^>]*>/g, ''),
                date: item.creation_time,
                tags: item.tags.map(tag => tag.name),
                attachments: item.attachments,
                url: 'dashboard/announcements/'
              })),
              totalCount: response.totalcount
            })
          )
        );
      })
    );
  }

  @Effect()
  public getAnnouncement() {
    return this.actions.pipe(
      ofType(AnnouncementsActionTypes.GET_ANNOUNCEMENT),
      exhaustMap((action: any) => {
        return this.announcementsService.getAnnouncement(action.id).pipe(
          map(announcement =>
            GetAnnouncementSuccess({
              announcement: {
                id: announcement.id,
                title: announcement.subject,
                description: announcement.message,
                date: announcement.creation_time,
                image: announcement.image,
                tags: announcement.tags.map(tag => tag.name),
                attachments: announcement.attachments,
                url: 'dashboard/announcements/'
              }
            })
          )
        );
      })
    );
  }
  constructor(
    private actions: Actions,
    private announcementsService: AnnouncementsService
  ) {}
}
